import api from './index';
import { setToken } from '../utils/authUtils';
import { appendQueryParamsToUrl } from '../utils';
import { fetchReadableStream } from './fetchReadableStream';
import { StrategicVolumeReleaseReportsForm } from '../types/StrategicVolume';
import { StrategicVolumeSummaryRow } from '@callmart/types';

const BASE = '/strategic-volume-report';

export const getStrategicVolumeReports = async ({
    location,
    dateFrom,
    dateTo,
    user,
    releaseType,
}: {
    location: number;
    dateFrom: string;
    dateTo: string;
    user: number;
    releaseType: number;
}) => {
    return api
        .get(`${BASE}/all-with-volumes`, { params: { location, dateFrom, dateTo, user, releaseType } })
        .then((res) => res.data);
};

export const createOneStrategicVolumeReport = async (data: any) => {
    return api.post(`${BASE}/one`, { data }, await setToken()).then((res) => res.data);
};

export const createStrategicVolumeReport = async ({ data, userId }: { data: any; userId: any }) => {
    return api.post(`${BASE}/create`, { data, userId }, await setToken()).then((res) => res.data);
};

export const markStrategicVolumeReportsRelease = async (data: {
    strategicVolumes: StrategicVolumeReleaseReportsForm[];
    releaseType: number;
}) => {
    return api.put(`${BASE}/markRelease`, { data }, await setToken()).then((res) => res.data);
};

export const compareStrategicVolumeAndCapacityReport = async (
    location: any,
    dateFrom: any,
    dateTo: any,
    user: any,
    releaseType: any
) => {
    let url = `${BASE}/compareWithCapacityReport`;
    url = appendQueryParamsToUrl(url, { location, dateFrom, dateTo, user, releaseType });

    return api.get(url, await setToken()).then((res) => res.data);
};

export const uploadStrategicVolumes = async ({
    data,
    userId,
    setPercentage,
}: {
    data: any;
    userId: any;
    setPercentage: any;
}) => {
    return await fetchReadableStream(`${BASE}/upload`, { data, userId }, setPercentage, '\n');
};

export const getLastStrategicVolumeUploadDate = async (location: any) => {
    return api.get(`${BASE}/lastUploadDate?location=${location}`, await setToken()).then((res) => res.data);
};

export const getStrategicVolumeReport = async ({
    workingUnitLocation,
    date,
}: {
    workingUnitLocation: any;
    date: any;
}) => {
    let url = appendQueryParamsToUrl(BASE, { workingUnitLocation, date });

    return api.get(url, await setToken()).then((res) => res.data);
};

export const getStrategicVolumeReportSummary = async ({ dateFrom, dateTo }: { dateFrom: string; dateTo: string }) => {
    return api
        .get<StrategicVolumeSummaryRow[]>(`${BASE}/summary`, { params: { dateFrom, dateTo } })
        .then((res) => res.data);
};
